import React from "react";
import classNames from "classnames";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Input({ selected, isOpen }: Props) {
  return (
    <div
      className={classNames(styles.input, {
        [styles.opened]: isOpen,
      })}
    >
      {!selected && (
        <p className={styles.placeholder}>Sélectionner une tâche</p>
      )}
      {!!selected && (
        <div className={styles.selected}>
          <p className={styles.name}>{selected.name}</p>
        </div>
      )}
      <ArrowIcon className={styles.toggleIcon} />
    </div>
  );
}

export { Input };
